import React from "react";

const Avatar = (props) => {
    return (
        <>
<div>
    <div className="avatar m-0 ">
        <div className="lg:mx-5 rounded-xl w-12">
            <img
                src={process.env.PUBLIC_URL + props.address}
                alt="Profile"
                className="m-0"
            />
        </div>
    </div>
</div>
        </>
    );
};

export default Avatar;
